import React from 'react';
import { Link } from 'react-router-dom';
import { BottomSheet } from './BottomSheet.js';
import { AppIcon } from './AppIcon.js';

export const DepositBottomSheet: React.FC<{
  readonly isOpen: boolean;
  readonly onClose: () => void;
}> = ({ isOpen, onClose }) => (
  <BottomSheet
    isOpen={isOpen}
    onClose={onClose}
    title="Add money"
    description="Wallet funding is not available yet."
  >
    <div className="workspace-stack">
      <span className="icon-tile">
        <AppIcon name="wallet" />
      </span>
      <p className="muted">
        Once funding is ready, you will be able to choose an amount and a supported network here.
        There is no deposit address for your account yet.
      </p>
      <Link className="ios-btn-primary" to="/preview" onClick={onClose}>
        Try the interactive preview <AppIcon name="arrow" />
      </Link>
      <p className="small-print">
        Do not send real cryptocurrency. The preview uses sample data only.
      </p>
    </div>
  </BottomSheet>
);
